import axiosClient from "../axios-client";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================

export const getNameCorrection = async (dispatch) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/name-correction/list`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Name correction orders not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// =================================== PUT API ===================================
// ===============================================================================

export const saveNewNameInOrder = async (dispatch, order_id, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/name-correction/place/${order_id}`, data)
        .then((res) => {
            toastMessage("Name updated successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Name correction order not saved", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};
